import type { CSSProperties, ImgHTMLAttributes } from 'react'

interface StaticImageProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'width' | 'height'> {
  alt: string
  fill?: boolean
  priority?: boolean
  sizes?: string
  width?: number | string
  height?: number | string
}

export default function StaticImage({
  alt,
  fill,
  priority,
  style,
  ...props
}: StaticImageProps) {
  const imageStyle: CSSProperties = fill
    ? {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        ...style,
      }
    : style || {}
  return (
    <img
      {...props}
      alt={alt}
      style={imageStyle}
      fetchPriority={priority ? 'high' : props.fetchPriority}
    />
  )
}
